import authorization from './authorization'
import visitor from './visitor'
import file from './file'
import login from './login'
import Epidemicprevention from './Epidemicprevention'
import worker from './worker'
import speech from './speech'
import courselearn from './courselearn'
import exam from './exam'
import coursemanage from './coursemanage'
import checkinmanage from './checkinmanage'
import environmentmanage from './environmentmanage'
import noticemanagement from './noticemanagement'
import visitormanagement from './visitormanagement'
import personmanagement from './personmanagement'
import archivesmanagement from './archivesmanagement'
import projectInfo from './projectInfo'
import inspectionmobile from './inspectionmobile'
import photographmobile from './photographmobile'
import reportbill from './reportbill'
import reportBillContent from './reportBillContent'
import dangerous from './dangerous'
import leaderCheck from './leaderCheck'
import user from './user'
import proInfoItem from './proInfoItem'
import disinfect from './disinfect'
import progressPlan from './progressPlan'
import Vue from 'vue'

import jump from './jump/index'

Vue.prototype.$api = {
  Epidemicprevention,
  authorization,
  visitor,
  login,
  file,
  worker,
  speech,
  courselearn,
  coursemanage,
  checkinmanage,
  environmentmanage,
  noticemanagement,
  visitormanagement,
  personmanagement,
  archivesmanagement,
  projectInfo,
  inspectionmobile,
  photographmobile,
  reportbill,
  reportBillContent,
  dangerous,
  exam,
  leaderCheck,
  user,
  jump,
  proInfoItem,
  disinfect,
  progressPlan
}



// WEBPACK FOOTER //
// ./src/api/index.js